import removeBracketsWithNumberFromTheEndOfTheString from './removeBracketsWithNumberFromTheEndOfTheString'

const getNumberedCopyName = (name: string, existingNames: string[]): string => {
  const baseName = removeBracketsWithNumberFromTheEndOfTheString(name)
  const existingBaseNames = existingNames.map((existingName) =>
    removeBracketsWithNumberFromTheEndOfTheString(existingName),
  )

  const copies = existingBaseNames.filter(
    (existingBaseName) => existingBaseName === baseName,
  )

  let copyNumber = copies.length
  let copyName = baseName.concat(copyNumber ? ` (${copyNumber})` : '')
  while (existingNames.includes(copyName)) {
    copyNumber++
    copyName = `${baseName} (${copyNumber})`
  }

  return copyName
}

export default getNumberedCopyName
